<div
  class="shimmer"
  [style.flex-direction]="direction()"
  [style.gap.px]="gap()">
  @for (column of columns(); track column) {
    <div
      class="pp-shimmer"
      [style.height.px]="height()"
      [style.width.px]="width()"></div>
  }
</div>
